import React from 'react';
import { Input } from '@cokitchen/cokitchen-components';

type Props = {
  active: boolean;
  onClick: () => void;
  icon: JSX.Element;
  description: string;
  title: string;
};
const TopupWalletCard = ({ active, onClick, icon, description, title }: Props) => {
  return (
    <div
      className={`cursor-pointer hover:bg-gray-14 transition-all h-[65px] py-4 px-4 flex items-center border rounded-md ${
        active ? 'border-red-5' : 'border-gray-14 '
      }`}
      onClick={onClick}>
      <div className='flex gap-4 items-center w-full'>
        {icon}
        <div className='flex flex-col grow'>
          <label className='text-sm font-medium'>{title}</label>
          <p className='text-xs text-gray-9'>{description}</p>
        </div>
        <Input type='radio' readOnly checkColor={active ? 'red' : 'darkgray'} checked={active} />
      </div>
    </div>
  );
};

export default TopupWalletCard;
